module.exports = __webpack_public_path__ + "img/neige_off.0f69a906.gif";